import { createSelector } from 'reselect'
import _ from 'lodash'

import parametersSelector from './parameters'
import { prepare_coin_number, prepare_currency_number } from 'core/utils'

const allDepositsSelector = state => state.calculations.prices.all_deposits

export default (namespace, dataSelector = state => state.calculations.estimates) => {
  const calculatorSelector = namespace => state => state.calculator[namespace]
  const userBalancesSelector = state => state.users.current.deposits.json

  return createSelector(
    parametersSelector,
    dataSelector,
    calculatorSelector(namespace),
    userBalancesSelector,
    allDepositsSelector,
    (
      parameters,
      { json: estimates, loading: estimates_loading },
      calculator,
      user_balances,
      { json: all_deposits, loading: all_deposits_loading }
    ) => {
      const default_currency_code =
        namespace === 'buy_tokens_form'
          ? _.first(_.keys(user_balances))
          : parameters['coin.rate_currency']
      const code = calculator.code || default_currency_code
      const result = (estimates.currencies && estimates.currencies[code]) || {}
      const isRightDirection = calculator.direction === 'right'
      const coin_amount = isRightDirection
        ? calculator.coin_amount
        : result.coin_amount || calculator.coin_amount
      const coin_price = !isRightDirection
        ? calculator.coin_price
        : result.coin_price || calculator.coin_price
      const isAllDeposits = calculator.all_deposits && !_.isEmpty(all_deposits)
      return {
        ...calculator,
        loading: isAllDeposits ? all_deposits_loading : estimates_loading,
        code,
        coin_amount: prepare_coin_number(parameters)(
          isAllDeposits ? all_deposits.coin_amount : coin_amount
        ),
        coin_price: prepare_currency_number(parameters)(
          isAllDeposits ? all_deposits.coin_price : coin_price,
          code
        ),
        bonus_percent:
          parseFloat(isAllDeposits ? all_deposits.bonus_percent : result.bonus_percent) || 0,
        coin_bonus:
          parseFloat(isAllDeposits ? all_deposits.coin_amount_bonus : result.coin_amount_bonus) ||
          0,
        coin_total:
          parseFloat(isAllDeposits ? all_deposits.coin_amount_total : result.coin_amount_total) ||
          0,
        deposits: all_deposits
      }
    }
  )
}



// WEBPACK FOOTER //
// ./src/selectors/calculator.js